module.exports = __webpack_public_path__ + "static/media/part-detail-slide-3.7d963dd6.jpg";